import { createI18n } from 'vue-i18n'

const savedLang = localStorage.getItem('lang') || 'en'

const messages = {
  en: {
    nav: {
      title: "Scytale",
      hi: "Hi, {name}",
      logout: "Logout",
      login: "Login",
      back: "Back"
    },
    footer: {
      rights: "© {year} Scytale App. All rights reserved."
    },
    lang: {
      me: "ME",
      en: "EN"
    },
    form: {
      createTitle: "",
      subtitle: "",
      titleLabel: "Title (Optional)",
      titlePlaceholder: "E.g., Access for client X",
      secretLabel: "Secret Content",
      secretPlaceholder: "Enter the password, message, API key...",
      methodLabel: "Visibility",
      methodPublic: "Everyone with a link",
      methodOrg: "Internal (Login Required)",
      protectionLabel: "Protection Method",
      protLinkOnly: "Link Only",
      protPassword: "Password",
      protEmail: "Email Code",
      addPassLabel: "Password",
      addPassPlaceholder: "Password to unlock",
      emailLabel: "Recipient Email",
      emailPlaceholderUser: "recipient",
      emailPlaceholderDomain: "example.com",
      emailHint: "An unlock code will be sent when the link is first opened.",
      emailInvalid: "Please enter a valid email address.",
      orgHint: "Only logged-in users from your organization can view this.",
      durationLabel: "Expires in",
      duration1h: "1 hour",
      duration5h: "5 hours",
      duration1d: "1 day",
      duration7d: "7 days",
      burnLabel: "Burn after first read",
      descPublicBold: "Anyone with the link",
      descPublicSuffix: "can view this secret.",
      descOrgBold: "Only logged-in users from your organization",
      descOrgSuffix: "can view this secret.",
      descProtPrefix: "Protected by",
      descLinkOnlyBold: "link only",
      descPasswordBold: "a password",
      descEmailBold: "an email verification code",
      descProtSuffix: ".",
      descExpiryPrefix: "Expires in",
      descExpirySuffix: ".",
      descBurn: "Will be deleted after the first read.",
      createButton: "Create Secret",
      creatingButton: "Creating...",
      successAlert: "Secret Created!",
      shareLink: "Shareable Link",
      copyButton: "Copy",
      copySuccess: "Link copied!",
      copyError: "Error copying. Please try manually.",
      passwordStrengthWeak: "Weak",
      passwordStrengthMedium: "Medium",
      passwordStrengthStrong: "Strong",
      passwordHint: "Min. 8 characters"
    },
    errors: {
      secretEmpty: "The secret content field cannot be empty.",
      passwordRequired: "A password is required for this protection type.",
      emailRequired: "A recipient email is required for this protection type.",
      emailInvalid: "Please provide a valid email address.",
      generic: "An unknown error occurred on the server.",
      ERR_SECRET_NOT_FOUND: "Link is invalid or the secret has been deleted.",
      ERR_LINK_EXPIRED: "This link has expired.",
      ERR_LOGIN_REQUIRED: "You must be logged in to access this secret.",
      ERR_PASSWORD_REQUIRED: "Password required to unlock.",
      ERR_INCORRECT_PASSWORD: "Incorrect password.",
      ERR_EMAIL_VERIFICATION_REQUIRED: "This secret requires email verification.",
      ERR_CODE_REQUIRED: "A verification code was sent. Please enter it below.",
      ERR_CODE_EXPIRED: "The verification code has expired. Please request a new one.",
      ERR_INCORRECT_CODE: "Incorrect code.",
      ERR_RATE_LIMITED: "You are doing that too often. Please wait a moment.",
      ERR_TOO_MANY_FAILED_ATTEMPTS: "Too many failed attempts.",
      ERR_TOO_MANY_CODE_REQUESTS: "You have requested the code too many times. Please check your inbox or wait.",
      passwordTooShort: "Password must be at least 8 characters long."
    },
    unlock: {
      title: "Unlock Secret",
      wait: "Please wait…",
      loginRequired: "This secret requires authentication to view.",
      passwordLabel: "Password",
      checking: "Checking...",
      unlockButton: "Unlock",
      sendingCode: "Sending Code...",
      sendCodeButton: "Send Verification Code",
      codeLabel: "Verification Code",
      verifying: "Verifying...",
      confirmCodeButton: "Confirm Code",
      contentLabel: "Secret Content",
      burnWarning: "Warning: If 'burn after read' was enabled, this secret will be deleted after you close it. Save the content now!",
      errorTitle: "Error",
      backHome: "Back to Home",
      errorNoCode: "Secret access code not found in URL.",
      codeSentInfo: "A verification code has been sent to the recipient's email.",
      codeSentPrompt: "Please enter the code you received.",
      preWarningTitle: "Warning",
      preWarningBody: "You are about to view a potentially sensitive secret. This secret may be set to delete itself after you read it. Save the content now!",
      preWarningConfirm: "Show Secret",
      preWarningCancel: "Cancel",
      resendWait: "You can request a new code in",
      resendButton: "Resend Code",
      createNew: "Create a new secret"
    },
    authCallback: {
      verifying: "Verifying…",
      wait: "Please wait while we complete the sign-in…",
      errorTitle: "Sign-In Error",
      redirect: "You will be redirected to the login page…",
      noCode: "Google authorization code not found in URL.",
      tokenFail: "Failed to exchange authorization code for a token.",
      googleError: "Error during Google sign-in: {detail}. Please try again."
    },
    login: {
      title: "Welcome",
      subtitle: "Please sign in to continue.",
      button: "Continue with Google",
      buttonGoogle: "Sign in with Google",
      buttonMicrosoft: "Sign in with Microsoft",
      googleInfo: "This application uses Google for authentication.",
      googleSubtext: "You will be redirected to Google sign-in page.",
      microsoftInfo: "This application uses Microsoft Azure AD for authentication.",
      microsoftSubtext: "You will be redirected to Microsoft sign-in page."
    },
    guide: {
      title: "How to use Scytale",
      step1title: "Sign In",
      step1desc: "Log in with your organization account to access the platform.",
      step2title: "Create a Secret",
      step2desc: "Enter your password, API key, or sensitive message and choose a protection method.",
      step3title: "Share the Link",
      step3desc: "Copy the generated link and send it to your recipient.",
      step4title: "Recipient Unlocks",
      step4desc: "The recipient opens the link and verifies their identity to view the secret."
    }
  },
  me: {
    nav: {
      title: "Scytale",
      hi: "Zdravo, {name}",
      logout: "Odjavi se",
      login: "Prijavi se",
      back: "Nazad"
    },
    footer: {
      rights: "© {year} Scytale aplikacija. Sva prava zadržana."
    },
    lang: {
      me: "ME",
      en: "EN"
    },
    form: {
      createTitle: "",
      subtitle: "",
      titleLabel: "Naslov (Opciono)",
      titlePlaceholder: "Npr., Pristup za klijenta X",
      secretLabel: "Sadržaj tajne",
      secretPlaceholder: "Unesi lozinku, poruku, API ključ...",
      methodLabel: "Vidljivost",
      methodPublic: "Svako ko ima link",
      methodOrg: "Interno (Potrebna prijava)",
      protectionLabel: "Metod zaštite",
      protLinkOnly: "Samo link",
      protPassword: "Lozinka",
      protEmail: "Email kod",
      addPassLabel: "Lozinka",
      addPassPlaceholder: "Lozinka za otključavanje",
      emailLabel: "Email primaoca",
      emailPlaceholderUser: "primalac",
      emailPlaceholderDomain: "primjer.com",
      emailHint: "Kod za otključavanje će biti poslat primaocu kada prvi put otvori link.",
      emailInvalid: "Unesite validnu email adresu.",
      orgHint: "Tajnu mogu vidjeti samo prijavljeni korisnici vaše organizacije.",
      durationLabel: "Ističe za",
      duration1h: "1 sat",
      duration5h: "5 sati",
      duration1d: "1 dan",
      duration7d: "7 dana",
      burnLabel: "Obriši nakon prvog čitanja",
      descPublicBold: "Svako ko ima link",
      descPublicSuffix: "može da vidi ovu tajnu.",
      descOrgBold: "Samo prijavljeni korisnici vaše organizacije",
      descOrgSuffix: "mogu da vide ovu tajnu.",
      descProtPrefix: "Zaštićena je",
      descLinkOnlyBold: "samo linkom",
      descPasswordBold: "lozinkom",
      descEmailBold: "email verifikacionim kodom",
      descProtSuffix: ".",
      descExpiryPrefix: "Ističe za",
      descExpirySuffix: ".",
      descBurn: "Biće obrisana nakon prvog čitanja.",
      createButton: "Kreiraj tajnu",
      creatingButton: "Kreiram...",
      successAlert: "Tajna je uspješno kreirana!",
      shareLink: "Link za dijeljenje",
      copyButton: "Kopiraj",
      copySuccess: "Link kopiran!",
      copyError: "Greška pri kopiranju. Pokušajte ručno.",
      passwordStrengthWeak: "Slaba",
      passwordStrengthMedium: "Srednja",
      passwordStrengthStrong: "Jaka",
      passwordHint: "Min. 8 karaktera"
    },
    errors: {
      secretEmpty: "Polje za sadržaj tajne ne može biti prazno.",
      passwordRequired: "Lozinka je obavezna za ovaj metod zaštite.",
      emailRequired: "Email primaoca je obavezan za ovaj metod zaštite.",
      emailInvalid: "Unesite validnu email adresu.",
      generic: "Desila se nepoznata greška na serveru.",
      ERR_SECRET_NOT_FOUND: "Link nije važeći ili je tajna obrisana.",
      ERR_LINK_EXPIRED: "Ovaj link je istekao.",
      ERR_LOGIN_REQUIRED: "Morate biti prijavljeni da biste pristupili ovoj tajni.",
      ERR_PASSWORD_REQUIRED: "Potrebna je lozinka za otključavanje.",
      ERR_INCORRECT_PASSWORD: "Pogrešna lozinka.",
      ERR_EMAIL_VERIFICATION_REQUIRED: "Ova tajna zahtijeva verifikaciju emailom.",
      ERR_CODE_REQUIRED: "Verifikacioni kod je poslat. Unesite ga ispod.",
      ERR_CODE_EXPIRED: "Verifikacioni kod je istekao. Molimo zatražite novi.",
      ERR_INCORRECT_CODE: "Pogrešan kod.",
      ERR_RATE_LIMITED: "Radite to previše često. Molimo sačekajte.",
      ERR_TOO_MANY_FAILED_ATTEMPTS: "Previše neuspješnih pokušaja.",
      ERR_TOO_MANY_CODE_REQUESTS: "Zatražili ste kod previše puta. Molimo provjerite inbox ili sačekajte.",
      passwordTooShort: "Lozinka mora imati najmanje 8 karaktera."
    },
    unlock: {
      title: "Otključaj Tajnu",
      wait: "Molimo sačekajte…",
      loginRequired: "Ova tajna zahtijeva prijavu za pregled.",
      passwordLabel: "Lozinka",
      checking: "Provjeravam...",
      unlockButton: "Otključaj",
      sendingCode: "Slanje koda...",
      sendCodeButton: "Pošalji Verifikacioni Kod",
      codeLabel: "Verifikacioni Kod",
      verifying: "Verifikujem...",
      confirmCodeButton: "Potvrdi Kod",
      contentLabel: "Sadržaj Tajne",
      burnWarning: "Upozorenje: Ako je 'brisanje nakon čitanja' aktivno, tajna će biti obrisana nakon što je zatvorite. Sačuvajte sadržaj sada!",
      errorTitle: "Greška",
      backHome: "Nazad na Početnu",
      errorNoCode: "Pristupni kod za tajnu nije pronađen u URL-u.",
      codeSentInfo: "Verifikacioni kod je poslat na email primaoca.",
      codeSentPrompt: "Molimo unesite kod koji ste primili.",
      preWarningTitle: "Upozorenje",
      preWarningBody: "Prikazaćete tajnu koja može biti osjetljiva. Ako je tako podešeno, tajna će biti automatski obrisana nakon što je pročitate. Sačuvajte sadržaj sada!",
      preWarningConfirm: "Prikaži tajnu",
      preWarningCancel: "Odustani",
      resendWait: "Novi kod možete zatražiti za",
      resendButton: "Pošalji kod ponovo",
      createNew: "Kreiraj novu tajnu"
    },
    authCallback: {
      verifying: "Verifikacija…",
      wait: "Molimo sačekajte dok dovršimo prijavu…",
      errorTitle: "Greška pri Prijavi",
      redirect: "Bićete preusmjereni na stranicu za prijavu…",
      noCode: "Google autorizacioni kod nije pronađen u URL-u.",
      tokenFail: "Neuspješna razmjena autorizacionog koda za token.",
      googleError: "Greška tokom Google prijave: {detail}. Molimo pokušajte ponovo."
    },
    login: {
      title: "Dobrodošli",
      subtitle: "Molimo prijavite se da nastavite.",
      button: "Nastavi uz Google",
      buttonGoogle: "Prijavite se sa Google-om",
      buttonMicrosoft: "Prijavite se sa Microsoft-om",
      googleInfo: "Ova aplikacija koristi Google za autentifikaciju.",
      googleSubtext: "Bićete preusmjereni na Google stranicu za prijavu.",
      microsoftInfo: "Ova aplikacija koristi Microsoft Azure AD za autentifikaciju.",
      microsoftSubtext: "Bićete preusmjereni na Microsoft stranicu za prijavu."
    },
    guide: {
      title: "Kako koristiti Scytale",
      step1title: "Prijavite se",
      step1desc: "Ulogujte se sa svojim organizacionim nalogom za pristup platformi.",
      step2title: "Kreirajte tajnu",
      step2desc: "Unesite lozinku, API ključ ili osjetljivu poruku i odaberite metod zaštite.",
      step3title: "Podijelite link",
      step3desc: "Kopirajte generisani link i pošaljite ga primaocu.",
      step4title: "Primalac otključava",
      step4desc: "Primalac otvara link i potvrđuje identitet da bi vidio tajnu."
    }
  }
}

const i18n = createI18n({
  legacy: false, 
  locale: savedLang,
  fallbackLocale: 'en',
  messages: messages
})

export default i18n